var _excluded = ["size"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';

var FlagMt16 = function FlagMt16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.882 2h12.236C15.158 2 16 2.843 16 3.882v7.53c0 1.04-.843 1.882-1.882 1.882H1.882A1.882 1.882 0 0 1 0 11.412v-7.53C0 2.842.843 2 1.882 2zm0 .47c-.78 0-1.411.633-1.411 1.412v7.53c0 .78.632 1.411 1.411 1.411h12.236a1.41 1.41 0 0 0 1.411-1.411v-7.53a1.41 1.41 0 0 0-1.411-1.411H1.882z",
    fill: "#D8DDE1"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 3.808v7.697c0 .722.575 1.307 1.285 1.307H8V2.5H1.785C1.075 2.5.5 3.086.5 3.808z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.239 2.5H8v10.313h6.239c.697 0 1.261-.586 1.261-1.309V3.809c0-.722-.565-1.308-1.261-1.308z",
    fill: "#EE2734"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.281 4.573a.207.207 0 0 0-.178-.179c.036.01.075.034.11.07a.276.276 0 0 1 .07.11H3.28zm.554.03v.54h-.548a.143.143 0 0 0-.003.02h.57v-.577h-.57l.002.02h.548v-.002zm-2.057.54v-.538h.548c0-.008.001-.013.003-.02h-.57v.577h.57a.075.075 0 0 1-.003-.019H1.78zm1.295.77H2.54v-.554c-.007 0-.013 0-.02-.002v.576h.572v-.576a.091.091 0 0 1-.02.002v.553zm.03-.56a.209.209 0 0 0 .178-.178.28.28 0 0 1-.069.109.258.258 0 0 1-.109.071v-.002zm-.771-.178c.007.087.09.172.177.178a.26.26 0 0 1-.108-.07.25.25 0 0 1-.07-.107v-.001zm.177-.781a.21.21 0 0 0-.18.18.293.293 0 0 1 .07-.11.25.25 0 0 1 .109-.07h.001zm.03-.56h.533v.554l.019.003v-.576h-.572v.576a.09.09 0 0 1 .019-.002v-.554h.001z",
    fill: "#FF172D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.796 4.643h-.52c0-.04-.012-.099-.079-.167-.067-.067-.114-.077-.162-.08v-.523h-.457v.528c-.034.008-.09.01-.158.077-.067.069-.078.123-.079.167h-.525v.461h.52c0 .03.003.088.07.156.068.068.117.082.175.085-.001 0-.003.178-.005.53h.458V5.35a.253.253 0 0 0 .172-.09.21.21 0 0 0 .064-.159c.001 0 .175.003.525.005v-.463l.001-.001z",
    fill: "#CECCCC"
  })));
};

FlagMt16.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var sizeMap = {
  '16': FlagMt16
};
export var FlagMt = function FlagMt(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '16' : _ref$size,
      props = _objectWithoutProperties(_ref, _excluded);

  var Icon = sizeMap[size] || sizeMap['16'];

  if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test' && !sizeMap[size]) {
    throw new Error("The '".concat(size, "' size is not supported by the 'FlagMt' icon. Please use one of the available sizes: '16'."));
  }

  return /*#__PURE__*/React.createElement(Icon, props);
};